import { useEffect } from "react";

/**
 * useEscapeKey — fires the supplied handler when the Escape key is pressed.
 * Skips work when `active` is false. Handler is read from a ref-like
 * closure on each render; passing a stable callback is recommended.
 */
export function useEscapeKey(handler, active = true) {
  useEffect(() => {
    if (!active) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") handler?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [active, handler]);
}

export default useEscapeKey;
